module.exports = __webpack_public_path__ + "static/media/servicestree@2x.45ae0b85.png";